import React from "react";

import type { ActivityContentGoalNameUpdating } from "@/api";
import type { Activity } from "@/models/activities";
import { Paths } from "@/routes/paths";
import { Trans } from "../i18n";
import { activityAuthorName, goalLink } from "../feedItemLinks";
import type { ActivityHandler, FeedItemProps } from "../interfaces";

const GoalNameUpdating: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(_paths: Paths, _activity: Activity) {
    throw new Error("Not implemented");
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle(props: FeedItemProps) {
    const { paths } = props;
    const { goal } = content(props.activity);

    if (props.page === "goal") {
      return <Trans i18nKey="{{author}} renamed the goal" values={{ author: activityAuthorName(props.activity) }} />;
    } else {
      return (
        <Trans
          i18nKey="{{author}} renamed <goal>{{goalName}}</goal>"
          values={{ author: activityAuthorName(props.activity), goalName: goal.name }}
          components={{ goal: goalLink(paths, goal) }}
        />
      );
    }
  },

  FeedItemContent(props: { activity: Activity; page: any }) {
    const { newName, oldName } = content(props.activity);

    return <Trans i18nKey="Previously it was {{oldName}}, now it is {{newName}}." values={{ oldName, newName }} />;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_props: { activity: Activity }) {
    return <></>;
  },

  NotificationLocation(_props: { activity: Activity }) {
    return null;
  },
};

function content(activity: Activity): ActivityContentGoalNameUpdating {
  return activity.content as ActivityContentGoalNameUpdating;
}

export default GoalNameUpdating;
